/* Claude PDP layer: add-to-cart click feedback + mobile sticky buy bar.
   Does not touch the theme's own add-to-cart logic — it only listens and mirrors.
   All element lookups are live because the theme can re-render product blocks. */
(function () {
  'use strict';

  var ADDED_TEXT = 'Added ✓';
  var ATC_SEL = 'block-buy-buttons button[name="add"]';

  function $(sel) { return document.querySelector(sel); }
  function mainBtn() { return $(ATC_SEL); }

  /* ---------- 0. Global: press feedback (pointer events — iOS ignores :active) + "Added" on theme event ---------- */
  var PRESS_SEL = 'block-buy-buttons button[name="add"], .gh-sticky-atc__btn, .quick-add-btn';
  function pressTarget(e) { var t = e.target && e.target.closest ? e.target.closest(PRESS_SEL) : null; return t; }
  document.addEventListener('pointerdown', function (e) { var t = pressTarget(e); if (t) t.classList.add('gh-pressed'); }, { passive: true });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      document.querySelectorAll('.gh-pressed').forEach(function (el) { el.classList.remove('gh-pressed'); });
    }, { passive: true });
  });
  function flashAdded(b) {
    if (!b || b.classList.contains('gh-added')) return;
    var span = b.querySelector('.gh-qa-label') || b.querySelector('span') || b;
    var label = span.textContent.trim();
    b.classList.add('gh-added');
    span.textContent = ADDED_TEXT;
    setTimeout(function () {
      b.classList.remove('gh-added');
      if (span.textContent === ADDED_TEXT) span.textContent = label;
    }, 2200);
  }
  // Theme fires this (bubbling) after a successful ajax add — PDP form and collection quick-add both.
  document.addEventListener('ajaxProduct:added', function (e) {
    var b = e.detail && e.detail.addToCartBtn;
    if (b && b.classList.contains('quick-add-btn')) flashAdded(b);
    else { flashAdded(mainBtn()); flashAdded($('.gh-sticky-atc__btn')); }
  });

  /* ---------- 0b. Hide hero media while a header drawer is open / settling (iOS re-composite flash) ---------- */
  (function () {
    var t = null;
    document.addEventListener('headerDrawer:opened', function () {
      clearTimeout(t);
      document.body.classList.remove('gh-drawer-settling');
      document.body.classList.add('gh-drawer-open');
    });
    document.addEventListener('headerDrawer:closed', function () {
      document.body.classList.remove('gh-drawer-open');
      document.body.classList.add('gh-drawer-settling');
      clearTimeout(t);
      t = setTimeout(function () { document.body.classList.remove('gh-drawer-settling'); }, 350);
    });
    // safety: never leave the hero hidden if a close event is missed
    setInterval(function () {
      if (document.body.classList.contains('gh-drawer-open') && !document.querySelector('.site-header__drawer.is-active')) {
        document.body.classList.remove('gh-drawer-open', 'gh-drawer-settling');
      }
    }, 2000);
  })();

  /* ---------- 0c. Confetti + offer toast (brand colours, 0.8s, respects reduced motion) ---------- */
  var COLORS = ['#1D6E77', '#D9B25A', '#F6E3DF', '#FBF8F3', '#B5473A', '#F3EDE3'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function confetti(x, y, n) {
    if (reduce) return;
    var c = document.createElement('canvas'); c.className = 'gh-confetti';
    var W = c.width = window.innerWidth, H = c.height = window.innerHeight;
    document.body.appendChild(c);
    var ctx = c.getContext('2d'), ps = [], i;
    x = typeof x === 'number' ? x : W / 2; y = typeof y === 'number' ? y : H * 0.3; n = n || 70;
    for (i = 0; i < n; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.6, s = 5 + Math.random() * 7;
      ps.push({ x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, w: 5 + Math.random() * 5, h: 3 + Math.random() * 4, r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, col: COLORS[i % COLORS.length] });
    }
    var t0 = performance.now(), D = 800;
    (function frame(t) {
      var k = (t - t0) / D; if (k >= 1) { c.remove(); return; }
      ctx.clearRect(0, 0, W, H); ctx.globalAlpha = 1 - Math.max(0, k - 0.6) / 0.4;
      ps.forEach(function (p) {
        p.vy += 0.28; p.vx *= 0.99; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.col; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore();
      });
      requestAnimationFrame(frame);
    })(t0);
  }
  function toast(html, ms) {
    var t = document.createElement('div'); t.className = 'gh-toast'; t.innerHTML = html; document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 350); }, ms || 2600);
  }
  window.ghConfetti = confetti; window.ghToast = toast;
  // (b) coupon "tap to copy" -> small burst at the button
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.gh-coupon[data-code]') : null;
    if (!b) return;
    var r = b.getBoundingClientRect(); confetti(r.left + r.width / 2, r.top + r.height / 2, 45);
  }, { passive: true });
  // (a) cart drawer opened with an automatic discount applied -> celebrate once per session per code
  function celebrateCart() {
    var drawer = document.querySelector('.site-header__cart');
    if (!drawer) return;
    var txt = drawer.textContent || '';
    var m = txt.match(/\b(FESTIVE10)\b/i);
    if (!m) return;
    var code = m[1].toUpperCase(), key = 'gh_celebrated_' + code;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (x) {}
    var amt = '';
    var am = txt.match(/FESTIVE10[^\d]{0,40}(?:-\s*)?(Rs\.?\s?[\d,]+(?:\.\d+)?|₹\s?[\d,]+(?:\.\d+)?)/i);
    if (am) amt = ' — you saved ' + am[1].replace(/\.\d+$/, '');
    setTimeout(function () { confetti(undefined, window.innerHeight * 0.25, 80); toast('🎉 <b>' + code + '</b> applied' + amt); }, 250);
  }
  document.addEventListener('headerDrawer:opened', function () { setTimeout(celebrateCart, 400); });
  document.addEventListener('cart:updated', function () { setTimeout(celebrateCart, 600); });

  /* ---------- (c) Quick add from reels / any [data-gh-quick-add] button ---------- */
  function quickAdd(btn) {
    var id = btn.getAttribute('data-gh-quick-add');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-ajax'] })
    }).then(function (r) { return r.json(); }).then(function (data) {
      btn.classList.remove('is-loading');
      if (data.status === 422 || data.status === 'bad_request' || data.description) { toast(data.description || 'Could not add to cart'); return; }
      // hand the response to the theme: it rebuilds + opens the cart drawer
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data, addToCartBtn: btn } }));
      var span = btn.querySelector('span') || btn; var label = span.textContent;
      btn.classList.add('gh-added'); span.textContent = ADDED_TEXT;
      var r = btn.getBoundingClientRect(); confetti(r.left + r.width / 2, r.top, 40);
      setTimeout(function () { btn.classList.remove('gh-added'); span.textContent = label; }, 2200);
    }).catch(function () { btn.classList.remove('is-loading'); toast('Could not add to cart'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-gh-quick-add]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); quickAdd(b);
  });

  /* ---------- (d) Floating shoppable video (product page) ---------- */
  function floatingVideo() {
    var box = document.querySelector('[data-gh-fv]');
    if (!box) return;
    var src = box.getAttribute('data-src'), srcHd = box.getAttribute('data-src-hd') || src, title = box.getAttribute('data-title') || '';
    if (!src) return;
    var mini = box.querySelector('.gh-fv__mini'), mv = box.querySelector('.gh-fv__mini-video');
    // prefer the lighter 720p rendition for the mini player (Liquid only exposes the top one)
    var handle = box.getAttribute('data-handle');
    if (handle && !/720p/.test(src)) {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var m = (p.media || []).filter(function (x) { return x.media_type === 'video'; })[0];
        var s720 = m && (m.sources || []).filter(function (x) { return x.format === 'mp4' && x.height <= 720 && x.height >= 480; }).sort(function (a, b) { return b.height - a.height; })[0];
        if (s720 && s720.url && !mv.getAttribute('src')) src = s720.url;
      }).catch(function () {});
    }
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('gh_fv_dismissed') === '1'; } catch (x) {}
    if (dismissed) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var loaded = false;
    function loadMini() { if (loaded) return; loaded = true; mv.src = src; mv.load(); }
    function playMini() { if (reduce) return; loadMini(); var p = mv.play(); if (p && p.catch) p.catch(function () {}); }

    // show after the gallery has scrolled away (or after 350px), hide while a header drawer / overlay is open
    var shown = false, overlayOpen = false;
    function update() {
      if (overlayOpen) return;
      var gallery = document.querySelector('.product__photos, .product-single__photos, product-images');
      var past = window.scrollY > 350;
      if (gallery) { var r = gallery.getBoundingClientRect(); past = r.bottom < 80; }
      var drawerOpen = !!document.querySelector('.site-header__drawer.is-active');
      var want = past && !drawerOpen;
      if (want !== shown) { shown = want; box.hidden = !want; box.classList.toggle('is-visible', want); if (want) playMini(); else mv.pause(); }
    }
    window.addEventListener('scroll', function () { setTimeout(update, 40); }, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 600);

    box.querySelector('.gh-fv__mini-close').addEventListener('click', function (e) {
      e.stopPropagation(); box.hidden = true; box.classList.remove('is-visible'); shown = false; mv.pause();
      dismissed = true; try { sessionStorage.setItem('gh_fv_dismissed', '1'); } catch (x) {}
      update = function () {};
    });

    // full-screen overlay
    var ov = null, fv = null;
    function priceText() {
      var price = $('block-price'); if (!price) return '';
      var sale = price.querySelector('.block-price__sale .element-price:not(.element-text--line-through)') || price.querySelector('.block-price__regular .element-price');
      var cmp = price.querySelector('.element-price.element-text--line-through');
      return (sale ? sale.textContent.trim() : '') + (cmp ? ' <s>' + cmp.textContent.trim() + '</s>' : '');
    }
    function openOverlay() {
      overlayOpen = true; mv.pause();
      if (!ov) {
        ov = document.createElement('div'); ov.className = 'gh-fv-overlay';
        ov.innerHTML =
          '<div class="gh-fv-overlay__stage">' +
          '<video class="gh-fv-overlay__video" playsinline loop muted></video>' +
          '<button type="button" class="gh-fv-overlay__close" aria-label="Close">&times;</button>' +
          '<button type="button" class="gh-fv-overlay__mute" aria-label="Sound"><span class="on">🔊</span><span class="off">🔇</span></button>' +
          '<div class="gh-fv-overlay__card">' +
          '<div class="gh-fv-overlay__title"></div>' +
          '<div class="gh-fv-overlay__price"></div>' +
          '<div class="gh-fv-overlay__row"><button type="button" class="gh-fv-overlay__atc element-button"><span>Add to cart</span></button>' +
          '<button type="button" class="gh-fv-overlay__details">View details</button></div>' +
          '</div></div>';
        document.body.appendChild(ov);
        fv = ov.querySelector('.gh-fv-overlay__video'); fv.src = srcHd;
        ov.querySelector('.gh-fv-overlay__close').addEventListener('click', closeOverlay);
        ov.querySelector('.gh-fv-overlay__details').addEventListener('click', closeOverlay);
        ov.addEventListener('click', function (e) { if (e.target === ov) closeOverlay(); });
        ov.querySelector('.gh-fv-overlay__mute').addEventListener('click', function () { fv.muted = !fv.muted; ov.classList.toggle('is-muted', fv.muted); });
        fv.addEventListener('click', function () { fv.muted = !fv.muted; ov.classList.toggle('is-muted', fv.muted); });
        ov.querySelector('.gh-fv-overlay__atc').addEventListener('click', function () {
          var b = mainBtn(); var mine = this;
          if (!b || b.disabled) { toast('Please choose a size/colour first'); closeOverlay(); return; }
          mine.classList.add('btn--loading');
          b.click(); // theme's own handler: ajax add + cart drawer + FESTIVE10 auto
          setTimeout(function () { mine.classList.remove('btn--loading'); closeOverlay(); }, 900);
        });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlayOpen) closeOverlay(); });
      }
      ov.querySelector('.gh-fv-overlay__title').textContent = title;
      ov.querySelector('.gh-fv-overlay__price').innerHTML = priceText();
      var b = mainBtn(); var atc = ov.querySelector('.gh-fv-overlay__atc');
      atc.disabled = !!(b && b.disabled); atc.querySelector('span').textContent = (b && b.disabled) ? (b.textContent.trim() || 'Sold out') : 'Add to cart';
      fv.muted = true; ov.classList.add('is-muted');
      ov.classList.add('is-open'); document.documentElement.classList.add('gh-fv-lock');
      box.hidden = true;
      var p = fv.play(); if (p && p.catch) p.catch(function () {});
      // one tap on the stage un-mutes (browsers block autoplay with sound)
      setTimeout(function () { try { fv.muted = false; ov.classList.remove('is-muted'); } catch (x) {} }, 50);
    }
    function closeOverlay() {
      if (!ov) return; overlayOpen = false;
      fv.pause(); ov.classList.remove('is-open'); document.documentElement.classList.remove('gh-fv-lock');
      shown = false; update();
    }
    mini.addEventListener('click', openOverlay);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', floatingVideo); else floatingVideo();

  function init() {
    if (!$('block-buy-buttons')) return;
    var section = $('block-buy-buttons').closest('.shopify-section') || document.body;

    // Title clamp (mobile CSS clamps to 3 lines) - tap the title to expand/collapse
    var h1 = $('.product-single__meta h1');
    if (h1) h1.addEventListener('click', function () { h1.classList.toggle('is-expanded'); });
    var stickyBtn = null;

    /* ---------- 1. Click feedback (loading -> "Added ✓") ---------- */
    function showAdded() { flashAdded(mainBtn()); flashAdded(stickyBtn); }

    // Theme sets aria-busy on the button while the ajax add runs; cleared without an error = success.
    var wasBusy = false;
    new MutationObserver(function (muts) {
      var b = mainBtn();
      if (!b) return;
      var touched = muts.some(function (m) { return m.target === b; });
      if (!touched) return;
      var busy = b.getAttribute('aria-busy') === 'true';
      if (busy) {
        wasBusy = true;
        if (stickyBtn) stickyBtn.classList.add('btn--loading');
      } else if (wasBusy) {
        wasBusy = false;
        if (stickyBtn) stickyBtn.classList.remove('btn--loading');
        var form = b.closest('form');
        if (!(form && form.querySelector('.errors'))) showAdded();
      }
    }).observe(section, { attributes: true, subtree: true, attributeFilter: ['aria-busy'] });

    /* ---------- 2. Mobile sticky buy bar ---------- */
    if (!$('.product-single__meta h1') || !$('block-price')) return;

    var bar = document.createElement('div');
    bar.className = 'gh-sticky-atc';
    bar.innerHTML =
      '<div class="gh-sticky-atc__info">' +
      '<div class="gh-sticky-atc__title"></div>' +
      '<div class="gh-sticky-atc__price"><span class="gh-sticky-atc__sale"></span> <s class="gh-sticky-atc__compare"></s></div>' +
      '</div>' +
      '<button type="button" class="gh-sticky-atc__btn element-button"><span>Add to cart</span></button>';
    document.body.appendChild(bar);

    stickyBtn = bar.querySelector('.gh-sticky-atc__btn');
    var tEl = bar.querySelector('.gh-sticky-atc__title');
    var saleEl = bar.querySelector('.gh-sticky-atc__sale');
    var cmpEl = bar.querySelector('.gh-sticky-atc__compare');

    function sync() {
      var title = $('.product-single__meta h1');
      var price = $('block-price');
      var b = mainBtn();
      if (title) tEl.textContent = title.textContent.trim();
      if (price) {
        var sale = price.querySelector('.block-price__sale .element-price:not(.element-text--line-through)') ||
                   price.querySelector('.block-price__regular .element-price');
        var cmp = price.querySelector('.element-price.element-text--line-through');
        saleEl.textContent = sale ? sale.textContent.trim() : '';
        cmpEl.textContent = cmp ? cmp.textContent.trim() : '';
        cmpEl.style.display = cmp ? '' : 'none';
      }
      if (b && !stickyBtn.classList.contains('gh-added')) {
        var disabled = b.hasAttribute('disabled');
        stickyBtn.disabled = disabled;
        stickyBtn.querySelector('span').textContent = disabled ? (b.textContent.trim() || 'Sold out') : 'Add to cart';
      }
    }
    sync();
    new MutationObserver(sync).observe(section, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    stickyBtn.addEventListener('click', function () {
      var b = mainBtn();
      if (!b || b.disabled) return;
      b.click(); // goes through the theme's own submit handler (ajax + cart drawer)
    });

    // Show the bar only while the real button is off-screen.
    var ticking = false;
    function update() {
      ticking = false;
      var b = mainBtn();
      if (!b) { bar.classList.remove('is-visible'); return; }
      var drawerOpen = !!document.querySelector('.site-header__drawer.is-active');
      var r = b.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var onScreen = r.height > 0 && r.bottom > 0 && r.top < vh - 10;
      bar.classList.toggle('is-visible', !onScreen && !drawerOpen);
    }
    function onScroll() {
      if (!ticking) { ticking = true; setTimeout(update, 60); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', update);
    // hide while the theme's cart / menu drawer is open (header drawers toggle .is-active)
    var drawers = document.querySelector('.site-header__drawers-container') || document.querySelector('.site-header');
    if (drawers) new MutationObserver(onScroll).observe(drawers, { attributes: true, subtree: true, attributeFilter: ['class'] });
    document.addEventListener('click', function () { setTimeout(update, 400); }, { passive: true });
    setTimeout(update, 300);
    setTimeout(update, 1500);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
